module.exports = __webpack_public_path__ + "static/media/icon_logout.68b93963.svg";